import React, { useEffect, useState } from "react";
import Block from "../Blocks/block";
import ContentWrapper from "../Blocks/contentWrapper";
import SectionWrapper from "../Blocks/sectionWrapper";
import BlockContent from "../Blocks/blockContent";
import Title from "../Blocks/title";
import Divider from "../Blocks/divider";
import Paragraph from "../Blocks/paragraph";
import USPSection from "../Blocks/USPSection";
import PageWrapper from "../Blocks/pageWrapper";
import { EColor, ESize } from "../../styleConstants";
import TextField from "../Blocks/textField";
import Button from "../Blocks/button";
import Form from "../Blocks/form";
import { validateEmail, validateEmailIsUnused, validatePassword, validatePresence } from "../validators";
import { emailUnused } from "../utils";
import Translate from "../Translate";
import LocaleImage from "../Blocks/localeImage";
import DisabledContent from "../Blocks/disabledContent";
import { rem, useIsMobile } from "../styleUtils";


async function register (email: string, password: string, recaptcha: string) {
    const CSRFToken = document.querySelector(`meta[name="csrf-token"]`).getAttribute("content")
    const data = new FormData()

    data.append('account[account][email]', email);
    data.append('account[account][password]', password);
    data.append('authenticity_token', CSRFToken);
    data.append('recaptcha', recaptcha);
    data.append('utf8', "✓");

    const response = await fetch("/accounts/create_remote", {
        method: 'POST',
        cache: 'no-cache',
        body: data,
        headers: {
            'Accept' : 'application/json',
            'X-CSRF-Token': CSRFToken
        },
    })

    const responseData = await response.json() as {
        errors: object
    }

    if (Object.keys(responseData.errors).length == 0) {
        const response = await fetch("/r/accept", {
            method: 'GET',
            cache: 'no-cache',
        })
        window.location.replace("/payment/details")
    }
}

function SignupForm ({tag} : {tag: string}) {

    const [email, setEmail] = useState<string>("")
    const [emailError, setEmailError] = useState<string>("")

    useEffect(() => {
        const w: any = window;
        w.enableReferRegistrationForm = function() {
            const recaptchaEl = document.getElementById('recaptcha-value') as HTMLInputElement;
            if (recaptchaEl) {
                recaptchaEl.value = "true"
            }
        }
    }, []);
    
    return (
        <div>
            <Form onSubmit={(fields) => {
                register(
                    fields.get("email").value,
                    fields.get("password").value,
                    (document.getElementById('g-recaptcha-response') as HTMLInputElement).value,
                )
            }}>
                <TextField 
                    name="email"
                    placeholder={Translate.path(`views.site_pages.refer_a_friend_campaign.common.signup_form.email`)}
                    validateOnBlur={true}
                    validators={[
                        validatePresence(Translate.path(`dictionary.validation.cant_be_blank`)),
                        validateEmail(Translate.path(`dictionary.validation.mail_wrong_format`)),
                        validateEmailIsUnused(emailUnused, Translate.path(`dictionary.validation.email_exists`)),
                    ]}
                />

                <TextField 
                    name="password"
                    placeholder={Translate.path(`views.site_pages.refer_a_friend_campaign.common.signup_form.password`)}
                    type="password-toggleable"
                    validateOnBlur={true}
                    validators={[
                        validatePresence(Translate.path(`dictionary.validation.cant_be_blank`)),
                        validatePassword(Translate.path(`dictionary.validation.passwd_at_least_char`))
                    ]}
                />

                <div style={{
                    marginBottom: rem(ESize.small),
                }}>
                    <div
                        className="g-recaptcha"
                        data-sitekey="6LcxXtcUAAAAAMlvBrZEz8nCc-F_svTakctMuTtf"
                        data-callback="enableReferRegistrationForm"
                    />
                </div>

                <div style={{display: "none"}}>
                    <input type="text" name="recaptcha-value" id="recaptcha-value" />
                </div>

                <Button submitButton={true} type="primary" label={Translate.path(`views.site_pages.refer_a_friend_campaign.common.signup_form.cta`)}></Button>
            </Form>
        </div>
    )
}


export default function FriendReferralReceiver ({
    referralLink,
    referralId,
    tag
}: {
    referralLink: string
    referralId: string
    tag: string
}) {
    const isMobile = useIsMobile()

    return (
        <PageWrapper>
            <SectionWrapper background={isMobile ? EColor.None : EColor.HeroGradientRussianOrange}>
                <ContentWrapper>
                    <Block>
                        <BlockContent bleed="none">
                            <Title size={8} margin={ESize.small}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.title`} />
                            </Title>
                            

                            <Paragraph size={4} margin={ESize.small}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.subtitle`} />
                            </Paragraph>

                            <SignupForm tag={tag} />

                            <Paragraph size={2} margin={ESize.small} color={EColor.MountainGray}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.disclaimer`} />
                            </Paragraph>
                        </BlockContent>
                        
                        <DisabledContent disableWhen="mobile">
                            <BlockContent bleed="right" verticalAlignment="end-no-padding">
                                <LocaleImage style={{maxHeight: 700, marginBottom: -100}} url="https://dnjpbxg2wcpr8.cloudfront.net/web/locale/refer_a_friend_devices_2021/" ext="png" />
                            </BlockContent>
                        </DisabledContent>

                    </Block>
                </ContentWrapper>
            </SectionWrapper>

            <USPSection usps={[
                Translate.path(`views.site_pages.refer_a_friend_campaign.common.usps.usp_1`),
                Translate.path(`views.site_pages.refer_a_friend_campaign.common.usps.usp_2`),
                Translate.path(`views.site_pages.refer_a_friend_campaign.common.usps.usp_3`),
                Translate.path(`views.site_pages.refer_a_friend_campaign.common.usps.usp_4`),
            ]} />
            
            {tag == "refer_a_friend_amazon_2021" && 
                <SectionWrapper>
                    <ContentWrapper>
                        <Block>
                            <BlockContent bleed="left">
                                <Title size={8} margin={ESize.small}>
                                    <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_1.title`} />
                                </Title>
                                <Paragraph size={6}>
                                    <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_1.body`} />
                                </Paragraph>
                            </BlockContent>
                            <BlockContent bleed="none">
                                <LocaleImage style={{maxHeight: `${rem(300)}`}} url="https://dnjpbxg2wcpr8.cloudfront.net/web/locale/refer_a_friend_amazon_gift_card_2021/" ext="png" />                           
                            </BlockContent>
                        </Block>
                    </ContentWrapper>
                </SectionWrapper>
            }

            <SectionWrapper> 
                <Divider />
            </SectionWrapper>

            <SectionWrapper>
                <ContentWrapper>
                    <Block reverseWhenMobile={true}>
                        <BlockContent bleed="none">
                            <LocaleImage style={{maxHeight: `${rem(327)}`, maxWidth: "100%"}} url="https://dnjpbxg2wcpr8.cloudfront.net/web/locale/refer_a_friend_app_rating_2021/" ext="png" />
                        </BlockContent>
                        <BlockContent bleed="right">
                            <Title size={8} margin={ESize.small}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_2.title`} />
                            </Title>
                            <Paragraph size={6}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_2.body`} />
                            </Paragraph>
                        </BlockContent>
                    </Block>
                </ContentWrapper>
            </SectionWrapper>

            <SectionWrapper> 
                <Divider />
            </SectionWrapper>

            <SectionWrapper>
                <ContentWrapper>
                    <Block>
                        <BlockContent bleed="left">
                            <Title size={8} margin={ESize.small}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_3.title`} />
                            </Title>
                            <Paragraph size={6}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_3.body`} />
                            </Paragraph>
                        </BlockContent>
                        <BlockContent bleed="right">
                            <img style={{maxHeight: rem(300)}} src="https://dnjpbxg2wcpr8.cloudfront.net/web/art/category-artwork.png" />
                        </BlockContent>
                    </Block>
                </ContentWrapper>
            </SectionWrapper>

            <SectionWrapper> 
                <Divider />
            </SectionWrapper>

            <SectionWrapper>
                <ContentWrapper>
                    <Block reverseWhenMobile={true}>
                        <BlockContent bleed="none" verticalAlignment="end-no-padding">
                            <LocaleImage style={{maxHeight: rem(827), marginBottom: rem(-350), maxWidth: "100%"}} url="https://dnjpbxg2wcpr8.cloudfront.net/web/locale/refer_a_friend_covers_2021/" ext="png" />
                        </BlockContent>
                        <BlockContent bleed="none">
                            <Title size={8} margin={ESize.small}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_4.title`} />
                            </Title>
                            <Paragraph size={6}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.receive.section_4.body`} />
                            </Paragraph>
                        </BlockContent>
                    </Block>
                </ContentWrapper>
            </SectionWrapper>
        </PageWrapper>
    )
}